import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import {
  ChangeLanguage,
  EditProfile,
  MyDocument,
  MyDocuments,
  Settings,
  ShareDocument,
  TermsAndPrivacy,
} from "./App"
import { Dashboard, NotFound, SignIn, TermsAndConditions } from "./"

import { useAuth } from "../contexts/Auth/AuthContext"

const Navigator = () => {
  const { isAuthenticated } = useAuth()

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate to={isAuthenticated ? "/dashboard" : "/auth/signin"} />
          }
        />
        <Route
          path="/auth/signin"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <SignIn />}
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? <Dashboard /> : <Navigate to="/auth/signin" />
          }
        />
        <Route
          path="/settings"
          element={
            isAuthenticated ? <Settings /> : <Navigate to="/auth/signin" />
          }
        />
        <Route
          path="/edit-profile"
          element={
            isAuthenticated ? <EditProfile /> : <Navigate to="/auth/signin" />
          }
        />
        <Route
          path="/my-documents"
          element={
            isAuthenticated ? <MyDocuments /> : <Navigate to="/auth/signin" />
          }
        />
        <Route
          path="/my-document/:documentId"
          element={
            isAuthenticated ? <MyDocument /> : <Navigate to="/auth/signin" />
          }
        />
        <Route
          path="/change-language"
          element={
            isAuthenticated ? (
              <ChangeLanguage />
            ) : (
              <Navigate to="/auth/signin" />
            )
          }
        />
        <Route
          path="/terms"
          element={
            isAuthenticated ? (
              <TermsAndPrivacy />
            ) : (
              <Navigate to="/auth/signin" />
            )
          }
        />
        <Route
          path="/service/terms-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route path="/share/:token" element={<ShareDocument />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Navigator
